//Get Strapi Brands Data ############

import { remark } from 'remark';
import html from 'remark-html';

import { normalizeSlug } from './search/url-utils';

//Help Function findLocalizedContent
const findLocalizedContent = async (data: any[], locale: string): Promise<any> => {
  const defaultContent = data.find(entry => entry.locale === 'en');
  if (!defaultContent) {
    return null;
  }

  const localizedContent = defaultContent.localizations?.find(
    (loc: { locale: string }) => loc.locale === locale
  );

  const processContent = async (content: any) => ({
    content_first_para: (
      await remark().use(html, { sanitize: false }).process(content.content_first_para)
    ).toString(),
    content_table: (
      await remark().use(html, { sanitize: false }).process(content.content_table)
    ).toString(),
    content_text: (
      await remark().use(html, { sanitize: false }).process(content.content_text)
    ).toString(),
  });

  const content = localizedContent ? localizedContent : { ...defaultContent, localizations: null };
  const processedContent = await processContent(content);

  return {
    ...content,
    ...processedContent,
  };
};

function getBrandNames(url: URL) {
  const path = url.pathname; // Extrae la parte del path
  // Maneja brands, category, country, region, selection, curation con o sin "/es"
  const regex = /(?:\/es)?\/(?:brands|category|country|region|selection|curation)\/(.+)/i;

  const match = path.match(regex);
  if (match && match[1]) {
    return match[1].split('+').map(part => normalizeSlug(part, true)); // Properly normalize each brand name
  }

  // Fallback auf Query-Parameter brand oder category
  const brandParam = url.searchParams.get('brand');
  if (brandParam) {
    return brandParam.split('+').map(part => normalizeSlug(part, true));
  }

  const categoryParam = url.searchParams.get('category');
  if (categoryParam) {
    return categoryParam.split('+').map(part => normalizeSlug(part, true));
  }

  return [];
}

const STRAPI_BASE = process.env.NEXT_PUBLIC_DEV_STRAPI_API_URL || 'https://strapi.spiritory.com';

/**
 * Baut eine vollständige Strapi-Bild-URL aus einem (evtl. relativen) Pfad.
 * @param u Der Bildpfad oder die URL.
 * @returns Die vollständige URL oder ein leerer String.
 */
const buildStrapiImageUrl = (u?: string): string => {
  if (!u) return '';
  try {
    if (u.startsWith('http://') || u.startsWith('https://')) return u;
    return new URL(u, STRAPI_BASE).toString();
  } catch {
    return u;
  }
};

export { findLocalizedContent, getBrandNames, buildStrapiImageUrl };
